module.exports = __webpack_public_path__ + "media/ding.b08fa562.mp3";